import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'truncate' })
export class TruncatePipe implements PipeTransform {
    transform(inputString: string, length: number): string {
        //return inputString.substring(0, length);
        if (inputString.length == length + 1) {
            return inputString;
        }
        else if (inputString.length > length) {
            var splitPoint = inputString.indexOf(' ', length) + 1;
            if (splitPoint > 0) {
                return inputString.substring(0, splitPoint) + "...";
            } else {
                return inputString;
            }
        }
        else {
            return inputString;
        }
    }
}
